








































import { Vue, Component, Watch } from "vue-property-decorator"
import ResourceHandbook from "./ResourceHandbook.vue"
import ResourceEntity from "./ResourceEntity.vue"
import PauseMenu from "./PauseMenu.vue"

@Component({
  components: {
    ResourceHandbook,
    ResourceEntity,
    PauseMenu
  }
})
export default class Tutorial extends Vue {
  public tutorials = [
    {
      class: "part1",
      text:
        "This is your money meter. Here you can see how much money you have.",
      triangle: "triangleup"
    },
    {
      class: "part2",
      text:
        "This is your Power Gauge. It shows you how much power you have. The green bar on the gauge represents how much power you currently have and it must pass the gray line to pass this round.",
      triangle: "triangleleft"
    },
    {
      class: "part3",
      text:
        "This is your Climate Gauge. It represents the climate of your town. It ranges from 1 to 100. If your town reaches a climate factor of over 80, you may be in danger of losing the game.",
      triangle: "triangleleft"
    },
    {
      class: "part4",
      text:
        "This is your Game Menu. Use this menu to keep track of the time. Here you can use the controls to speed up, slow down or pause the game.",
      triangle: "triangleup"
    },
    {
      class: "part5",
      text: "This is the pause menu. Here you can restart the game, take the tutorial, or view the instructions again. This menu can also be reached by hitting a spacebar.",
      triangle: "triangleright"
    },
    {
      class: "part6",
      text: "The Game Menu also contains your resources handbook.",
      triangle: "triangleup"
    },
    {
      class: "part7",
      text:
        "The Resources Handbook has information on all of the resources in the game, including resource duration, resource revenue and mega watt production.",
      triangle: "triangledown"
    },
    {
      class: "part8",
      text:
        "This is your Resources Menu. Here you can buy different energy sources for your town. Each resource has a limited quantity.",
      triangle: "triangledown"
    },
    {
      class: "part9",
      text:
        "When you buy a resource you will see it appear on the map. Before a resource can produce energy it must be constructed. This is represented by the yellow progress bar on your resource.",
      triangle: "triangleup"
    },
    {
      class: "part10",
      text:
        "Once construction is finished on your resource you will see a Resource Overview. Here you can see how many units of a particular resource you have, the energy they are providing, and the climate cost for those units.",
      triangle: "triangleup"
    }
  ]
  public index = 0

  @Watch("index")
  protected watchForEnd() {
    if (this.index >= this.tutorials.length) {
      this.$store.dispatch("endTutorial")
    }
  }

  protected back() {
    if (!this.$store.state.muted) {
      new Howl({
        src: ["/audio/Click.mp3"]
      }).play()
    }
    if (this.index === 0) {
      // end the tutorial
      this.index = this.tutorials.length
    } else {
      this.index--
    }
    this.$store.dispatch("setTutorialIndex", this.index)
  }

  protected next() {
    if (!this.$store.state.muted) {
      new Howl({
        src: ["/audio/Click.mp3"]
      }).play()
    }
    this.index =
      this.index === this.tutorials.length ? this.index : this.index + 1
    this.$store.dispatch("setTutorialIndex", this.index)
  }
}
